import { getApiOrganizations } from "@charphq/api-client";

/** An organization the current user belongs to, plus their role in it. */
export interface NavOrganization {
  id: string;
  name: string;
  /** The user's role in this org ("owner"/"admin"/… or "super_admin"); null if none. */
  currentUserRole?: string | null;
}

/**
 * Shared react-query options for "the organizations the current user can act in".
 * Used by both the sidebar org switcher and the API-keys page (to derive the active-org
 * role), so they share a single cache entry / fetch. Membership-scoped; super admins see
 * all orgs. Callers gate `enabled` on authentication.
 */
export const navOrganizationsQuery = {
  queryKey: ["nav-organizations"] as const,
  queryFn: async (): Promise<NavOrganization[]> => {
    const res = (await getApiOrganizations({ limit: 100, offset: 0 })) as {
      data?: Array<{ id: string; name: string; currentUserRole?: string | null }>;
    };
    return (res.data ?? []).map((o) => ({
      id: o.id,
      name: o.name,
      currentUserRole: o.currentUserRole ?? null,
    }));
  },
  staleTime: 5 * 60 * 1000,
};

/** Whether `role` may manage the active organization's resources (keys, members, …). */
export function roleCanManageOrg(role: string | null | undefined): boolean {
  return role === "owner" || role === "admin";
}
